// Handles form confirmation
document.addEventListener("submit", (e: Event) => {
	const form = e.target as HTMLFormElement
	const msg = form.getAttribute("data-confirm")

	if (msg && !confirm(msg)) {
		e.preventDefault()
	}
})

// Active-link highlighting via URL path matching
//
// Register any container whose child links declare, via data-active /
// data-inactive, the CSS classes for each state. On htmx swaps (and initial
// load) the classes are toggled based on window.location. A link is active at
// its own href, plus any extra URL it declares via data-match (used, for
// example, by the file shown in the Viewer pane by default).
const _activeLinkContainers = new Set<string>()
let _listenerAttached = false

// Walk every registered container and toggle active/inactive classes on child
// links using their data-active / data-inactive attributes
function _updateActiveLinks(): void {
	const currentPath = window.location.pathname

	_activeLinkContainers.forEach((id) => {
		const container = document.getElementById(id)

		if (!container) {
			return
		}

		container.querySelectorAll<HTMLAnchorElement>(
			"a[data-active][data-inactive]",
		).forEach((link) => {
			const href = link.getAttribute("href") || ""
			const extraMatch = link.dataset.match
			const isActive =
				currentPath === href.split("?")[0] ||
				(!!extraMatch && currentPath === extraMatch)

			const toAdd =
				(isActive ? link.dataset.active : link.dataset.inactive) || ""
			const toRemove =
				(isActive ? link.dataset.inactive : link.dataset.active) || ""

			if (toRemove) {
				link.classList.remove(...toRemove.trim().split(/\s+/))
			}

			if (toAdd) {
				link.classList.add(...toAdd.trim().split(/\s+/))
			}
		})
	})
}

// Register a container id so its child links are auto-activated on htmx swaps
// and initial page load
function registerActiveLinkContainer(id: string): void {
	_activeLinkContainers.add(id)

	if (!_listenerAttached) {
		document.addEventListener("htmx:afterSwap", _updateActiveLinks)
		_listenerAttached = true
	}

	// Run immediately in case the page loaded without an htmx swap
	_updateActiveLinks()
}

if (typeof window !== "undefined") {
	;(window as any).registerActiveLinkContainer = registerActiveLinkContainer
}

// Register known active-link containers
registerActiveLinkContainer("repo-subtabs")
registerActiveLinkContainer("repo-file-tree")
